<template>
	<div>
		<!--div class="sousuo" style="width: 100%">
            <div style="width: 450px" class="yl-flex flex_between">
                <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
            </div>
            <div style="width: 150px">
                <Button class="ivu-btn-circle" @click="batchGiveOut" type="primary">批量分配</Button>
            </div>
        </div-->
		<div>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="mySearch">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
						placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input v-model="name" style="width:200px" placeholder="手机号/姓名" />
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">状态</span>
					<Select v-model="status" multiple clearable style="width:200px" placeholder="状态">
						<Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">星级</span>
					<Select v-model="start" clearable style="width:150px;" placeholder="星级">
						<Option v-for="item in starsFilters" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">备注</span>
					<Input v-model="remark" placeholder="备注" style="width: 150px" />
				</div>
				</Col>
			</Row>
		</div>
		<Row style="padding-top: 20px;">
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">媒体代码</span>
				<Select filterable v-model="mediumCodeId" clearable style="width:200px" placeholder="媒体代码">
					<Option v-for="item in mediumCodeIdList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">媒体平台</span>
				<Select filterable v-model="mediumId" clearable style="width:200px" placeholder="媒体平台">
					<Option v-for="item in mediumList" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">城市</span>
				<Select v-model="city" style="width:150px" placeholder="请选择城市">
					<Option v-for="item in cityList" :value="item.city" :key="item.city">
						{{ item.city }}
					</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">分公司</span>
				<Select v-model="shopId" clearable style="width:200px" placeholder="选择渠道">
					<Option v-for="item in shopList" :value="item.value" :key="item.value">
						{{ item.label }}
					</Option>
				</Select>
			</div>
			</Col>
		</Row>
		<Row style="padding-top: 20px;">
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">是否重复申请</span>
				<Select v-model="is_repeat" clearable style="width: 170px">
					<Option value=1>是</Option>
					<Option value=0>否</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">重复申请时间</span>
				<DatePicker type="daterange" :value="repeat_time" placeholder="重复申请时间" @on-change="applyTimeChange">
				</DatePicker>
				</Cascader>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<Button @click="mySearch" type="primary" style="margin-left: 20px;">查询</Button>
			</Col>
		</Row>
		<Row style="padding-top: 20px;">
			<Col style="float: left;">
			<Button type="primary" @click="initSearch" style="margin-left: 20px;">重置刷新</Button>
			<Button type="primary" @click="batchGiveOut" style="margin-left: 20px;">批量分配</Button>
			<Button type="primary" @click="()=>{uploadModal = true}" style="margin-left: 20px;">导入数据</Button>
			<Button style="margin-left: 20px;" @click="()=>{addClientModal = true}" type="primary">添加客户</Button>
			</Col>
		</Row>
		<div style="width: 100% ;margin-top: 20px;">
			<Table border :columns="columns" :data="datas" ref="table" :row-class-name="rowClassName">
				<template slot-scope="{row,index}" slot="qualification_label">
					<div title="" class="cell el-tooltip" >
						<span class="ml10 mt5 el-tag el-tag--small " v-if="row.is_house == 1" style="font-size: 13px;">房</span>
						<span class="ml10 mt5 el-tag el-tag--small" v-if="row.is_car == 1" style="margin-left: 5px;font-size: 13px;" >车</span>
						<span class="ml10 mt5 el-tag el-tag--small " v-if="row.is_accumulation == 1" style="margin-left: 5px;font-size: 13px;">公积金</span>
						<span class="ml10 mt5 el-tag el-tag--small" v-if="row.is_social_security == 1" style="margin-left: 5px;font-size: 13px;">社保</span>
					</div>
				</template>
				<template slot-scope="{row,index}" slot="result">
					<Button type="primary" size="small" style="margin-right: 2px"
						@click="showResult(row,index)">查看</Button>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="error" size="small" :data-id="row.id" @click="delClient">删除</Button>
				</template>
				<template slot-scope="{ row }" slot="operation">
					<div style="text-align: left">
						<span v-if="row.distribute_status == 0" :data-id="row.id" @click="giveOut"
							style="color: #63B3E6; cursor: pointer;">手动分配</span>
						<span v-else style="cursor: pointer;">--</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="loans_money">
					<span>{{row.loans_money/10000}}万</span>
				</template>
				<template slot-scope="{ row }" slot="entrust">
					<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.content}}
						{{item.created_at}}
					</div>
					<div v-if="row.entrust.length == 0"></div>
				</template>
			</Table>
		</div>
		<div class="pager1">
			<Page :total="count" show-total show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				@on-page-size-change="changeSize" :current="page" @on-change="changePage" size="small" show-elevator />
		</div>
		<!-- 选择分配人 -->
		<Modal v-model="giveOutModal" width="650" title="选择分配商户">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">分配给</div>
				<RadioGroup v-model="giveOutShopId" class="in-block" style="width: 93%">
					<Radio v-for="item in shopList" :label="item.id"><span>{{item.name}}</span></Radio>
				</RadioGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="giveOutSure">确定</Button>
			</div>
		</Modal>
		<!-- 新增客户 -->
		<Modal v-model="addClientModal" width="45%" title="">
			<Form ref="formValidate" :model="client" :rules="ruleValidate" :label-width="80">
				<Row>
					<Col span="11">
					<FormItem label="姓名" prop="name">
						<Input v-model="client.name" placeholder="请输入姓名"></Input>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="电话号码" prop="phone">
						<Input v-model="client.phone" placeholder="请输入电话号码"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="11">
					<FormItem label="城市" prop="city">
						<Input v-model="client.city" placeholder="请输入城市"></Input>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="性别" prop="sex">
						<Select v-model="client.sex" placeholder="请选择性别">
							<Option :value="1">男</Option>
							<Option :value="2">女</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="11">
					<FormItem label="渠道id" prop="medium_code_id">
						<Select v-model="client.medium_code_id" placeholder="请选择媒体代码">
							<Option v-for="item in mediumCodeIdList" :value="item.value" :key="item.value">
								{{ item.name }}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="贷款额度" prop="loans_money">
						<Input v-model="client.loans_money" placeholder="请输入贷款额度"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="11">
					<FormItem label="房" prop="is_house">
						<Select v-model="client.is_house" placeholder="请选择房产情况">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="车" prop="is_car">
						<Select v-model="client.is_car" placeholder="请选择车辆情况">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="11">
					<FormItem label="公积金" prop="is_accumulation">
						<Select v-model="client.is_accumulation" placeholder="请选择公积金">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="社保" prop="is_social_security">
						<Select v-model="client.is_social_security" placeholder="请选择社保">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="11">
					<FormItem label="代发工资" prop="is_salary">
						<Select v-model="client.is_salary" placeholder="请选择代发工资">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="2" style="text-align: center">
					</Col>
					<Col span="11">
					<FormItem label="微粒贷" prop="is_weilidai">
						<Select v-model="client.is_weilidai" placeholder="请选择微粒贷">
							<Option :value="1">有</Option>
							<Option :value="0">无</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<FormItem>
					<Button @click="handleReset('formValidate')" style="margin-left: 200px">重置</Button>
					<Button type="primary" @click="handleSubmit('formValidate')" style="margin-left: 20px">提交</Button>
				</FormItem>
			</Form>
			<div slot="footer">
			</div>
		</Modal>
		<!--上传资料modal-->
		<Modal v-model="uploadModal" title="导入数据" width="600px" @on-cancel="() => {uploadModal = false}">
			<Steps :current="current_import_step">
				<Step title="上传文件" content="导入文件"></Step>
				<Step title="导入数据" content="导入数据"></Step>
				<Step title="导入完成" content="导入完成"></Step>
			</Steps>
			<div class="flex flex_between" style="padding: 5px 30px">
				一、根据模板准备要导入的数据。<span><a href="https://jzgtest.gzldr.com/static/uploads/demo.xlsx"
						style="color: #00a0e9">点击下载模板</a></span>
			</div>
			<div style="padding: 5px 30px">
				二、导入方式
				<div>
					<Form ref="importFormValidate" :model="importData" :rules="importRules" :label-width="100">
						<FormItem label="导入类型" prop="importType">
							<Select v-model="importData.importType" placeholder="请选择导入类型">
								<Option :value="1">新数据</Option>
								<Option :value="2">老数据</Option>
								<Option :value="3">短信</Option>
							</Select>
						</FormItem>
						<FormItem v-if="importData.importType == 2" label="导入分公司" prop="importShopid">
							<Select v-model="importData.importShopid" @on-change="getShopUser" placeholder="请选择导入公司">
								<Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.name }}
								</Option>
							</Select>
						</FormItem>
						<FormItem v-if="importData.importType == 2" label="导入员工" prop="importUid">
							<Select v-model="importData.importUid" placeholder="请选择导入员工">
								<Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.name }}
								</Option>
							</Select>
						</FormItem>
					</Form>
				</div>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				三、选择导入文件
				<Upload :before-upload="handleUpload" :on-success="uploadSuccess" :data="importData"
					:action="actionUrl">
					<Button icon="ios-cloud-upload-outline"
						:loading="loadingStatus">{{loadingStatus?'导入中':'选择文件'}}</Button>
				</Upload>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<span>总数量：{{importDetailData.success+importDetailData.is_exist_num+importDetailData.is_phone_num}}
					成功数量：{{importDetailData.success}} 撞库数量：{{importDetailData.is_exist_num}}
					手机号错误数量：{{importDetailData.is_phone_num}}</span>
			</div>
		</Modal>
	</div>
</template>
<script>
	import config from '../../config';
	import cityData from '../../assets/citydata.js'
	import {
		getAllMediumCode,
		getAllMedium,
		clientDistributeList,
		getAllShop,
		clientDistribute,
		getUserByShopId,
		importClient,
		getAllCity,
	} from "../../api/runSet";
	import {
		addClient,
		delClient
	} from "../../api/client";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "client_statistics",
		components: {},
		data() {
			return {
				pageSize: 10,
				pageSizeOpts: [10, 50, 100],
				distribute_status: 0,
				shopList: [],
				importDetailData: {},
				userList: [],
				giveOutShopId: 0,
				giveOutId: 0,
				giveOutModal: false,
				uploadModal: false,
				addClientModal: false,
				current_import_step: 0,
				actionUrl: '',
				fileName: '',
				fileUrl: '',
				file: '',
				loadingStatus: false,
				mediumCodeId: '',
				mediumId: '',
				mediumCodeIdList: [],
				mediumList: [],
				cityList: [],
				cityData: cityData,
				city: '',
				apply_time: [],
				join_time: [],
				repeat_time: [],
				is_repeat: 0,
				notFollowTimeValue: '',
				remark: '',
				modal: false,
				count: 0,
				page: 1,
				name: '',
				is_display_result: false,
				timePeriod: '5',
				timePeriodDate: [],

				datas: [],
				start: [],
				status: [],
				is_follow: false,
				is_house: '',
				is_car: '',
				is_accumulation: '',
				is_social_security: '',
				is_weilidai: '',
				is_salary: '',
				is_credit_card: '',
				is_pay_taxes: '',
				statusFilters: [{
					label: '未处理',
					value: '1'
				}, {
					label: '待跟进',
					value: '2'
				}, {
					label: '邀约中',
					value: '3'
				}, {
					label: '上门未签约',
					value: '6'
				}, {
					label: '已签约',
					value: '7'
				}, {
					label: '进件中',
					value: '8'
				}, {
					label: '银行拒绝',
					value: '9'
				}, {
					label: '已回款',
					value: '13'
				}, {
					label: '资质不符',
					value: '14'
				}, {
					label: '捣乱申请',
					value: '15'
				}, {
					label: '外地申请',
					value: '16'
				}, {
					label: '重复申请',
					value: '17'
				}],
				starsFilters: [{
						value: 0,
						label: '0星'
					},
					{
						value: 1,
						label: '1星'
					},
					{
						value: 2,
						label: '2星'
					},
					{
						value: 3,
						label: '2星+'
					},
					{
						value: 4,
						label: '3星'
					},
					{
						value: 5,
						label: '4星'
					},
				],
				conditionLise: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: '有'
					}
				],
				columns: [{
						type: 'selection',
						width: 60,
						"align": "center"
					},
					{
						"title": "姓名",
						"key": "name",
						"align": "center",
						"width": 80
					},
					{
						"title": "备注",
						"slot": "entrust",
						"align": "center",
						"width": 350
					},
					{
						"title": "星级",
						"key": "start_name",
						"align": "center",
						"width": 80
					},
					{
						"title": "贷款金额",
						"slot": "loans_money",
						"align": "center",
						"width": 100,
					},
					{
						"title": "城市",
						"key": "city",
						"align": "center",
						"width": 100,
					},
					{
						"title": "分发公司",
						"align": "center",
						"key": "company_name",
						"width": 100
					},
					{
						"title": "媒体代码",
						"key": "medium_code_name",
						"align": "center",
						"width": 130
					},
					{
						"title": "资质标签",
						"align": "center",
						"slot": "qualification_label",
						"width": 250
					},
					{
						"title": "申请时间",
						"key": "applied_at",
						"width": 150,
						"align": "center",
						"sortable": true
					},
					{
						"title": "状态",
						"align": "center",
						"key": "status",
						"width": 100
					},
					{
						"title": "老系统id",
						"align": "center",
						"key": "old_src_id",
						"width": 100
					},
					{
						"title": "分发结果",
						"align": "center",
						"slot": "result",
						"width": 80
					},
					{
						"title": "状态",
						"key": "status_name",
						"width": 100,
						"align": "center",
						filters: [{
							value: 1,
							label: '已分发'
						}, {
							value: -1,
							label: '未分发'
						}],
						filterMultiple: false,
						filterRemote(value, row) {
							this.mySearchByStatus(value);
						}
					},
					{
						"title": "操作",
						"align": "center",
						"slot": "action",
						"width": 80
					},
				],
				importData: {
					importType: 2,
				},
				client: {
					'name': '',
					'phone': '',
					'sex': '',
					'city': '',
					'age': '',
					'medium_code_id': '',
					'loans_money': '',

				},
				shopId: '',
				ruleValidate: {
					name: [{
						required: true,
						message: '姓名不能为空',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '电话不能为空',
						trigger: 'blur'
					}, ],
					city: [{
						required: true,
						message: '城市不能为空',
						trigger: 'blur'
					}],
					loans_money: [{
						required: true,
						message: '贷款额度不能为空',
						trigger: 'blur'
					}],
				},
				importRules: {
					importType: [{
						required: true,
						message: '请选择导入类型',
						trigger: 'blur'
					}],
					importShopid: [{
						required: true,
						message: '请选择导入分公司',
						trigger: 'blur'
					}, ],
				},
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.actionUrl = config.baseUrl.dev + '/app/api/importClient';
			this.loadData();
			this.getList();
		},
		methods: {
			mySearchByStatus(status) {
				this.status = status[0];
				this.page = 1;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			rowClassName(row, index) {
				if (row.distribute_status == 0) {
					return 'table-blue-row';
				} else {
					return 'table-black-row';
				}
			},
			initSearch() {
				this.name = '';
				this.timeDimension = [];
				this.timePeriod = '5';
				this.notFollowTime = false;
				this.page = 1;
				this.apply = [];
				this.media = [];
				this.start = [];
				this.status = [];
				this.clientType = [];
				this.timePeriodDate = [];
				this.apply_time = [];
				this.mediumCodeId = [];
				this.mediumId = [];
				this.shopId = '';
				this.join_time = [];
				this.notFollowTimeValue = "";
				this.is_house = '';
				this.is_car = '';
				this.is_accumulation = '';
				this.is_social_security = '';
				this.is_weilidai = '';
				this.is_salary = '';
				this.is_credit_card = '';
				this.is_pay_taxes = ';';
				this.is_repeat = 0;
				this.repeat_time = [];
				this.city = '';
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllMediumCode(that, data);
				that.mediumCodeIdList = res.data.list;
				res = await getAllMedium(that, data);
				that.mediumList = res.data.list;
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getAllCity(that, data);
				that.cityList = res.data.list;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await clientDistributeList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			search() {
				this.page = 1;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			mySearch() {
				this.page = 1;
				this.getList();
			},
			applyTimeChange(e) {
				this.repeat_time = e;
				this.getList();
			},
			joinTimeChange(e) {
				this.join_time = e;
				this.getList();
			},
			batchGiveOut() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				that.giveOutId = [];
				selectTion.forEach(function(e) {
					that.giveOutId.push(e.id);
				})
				this.giveOutModal = true;
			},
			addClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					let res = await addClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addClientModal = false;
						that.getList();
					}
				}, 500)
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						let that = this;
						if (that.client.medium_code_id == '' || that.client.medium_code_id == null) {
							that.$Message.error('请选择渠道id');
							return
						}
						this.throttle(async function() {
							let data = {
								token: that.token,
								data: that.client
							};
							let res = await addClient(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.addClientModal = false;
								that.getList();
							}
						}, 500)
					} else {
						this.$Message.error('保存失败');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			getShopUser(shopId) {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						shopId: shopId
					};
					let res = await getUserByShopId(that, data);
					if (res.code == 1) {
						that.userList = res.data.list;
					}
				}, 500)
			},
			uploadSuccess(e) {
				var that = this;
				that.loadingStatus = false;
				that.importDetailData = e.data
				if (e.code != 1) {
					that.$Message.warning(e.msg);
					return;
				}
			},
			showResult(row, index) {
				var i = 0;
				var content = '';
				for (i = 0; i < this.datas[index].distribute.length; i++) {
					content += this.datas[index].distribute[i].ext_info.remark + "<br>";
				}
				this.$Modal.info({
					title: '分发结果',
					content: content
				})
			},
			// 删除充值
			delClient(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delClient(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			giveOut(e) {
				this.giveOutId = e.currentTarget.dataset.id;
				this.giveOutModal = true;
			},
			giveOutSure() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						id: that.giveOutId,
						shopId: that.giveOutShopId
					};
					let res = await clientDistribute(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 500)
			},
			fileSubmit() {
				var that = this;
				var token = that.token;
				var name = that.fileName;
				var file = that.fileUrl;
				importClient({
					token,
					name,
					file
				}).then(function(res) {
					res = res.data;
					if (res.code != 1) {
						that.$Message.warning(res.msg);
						if (res.code == -2) {
							that.handleLogOut();
							that.$router.push({
								name: 'login'
							})
						}
						return;
					}
					that.$Message.success(res.msg);
					that.fileName = '';
					that.fileUrl = '';
					that.uploadModal = false;
					that.loadData();
				});
			},
			uploadFile(e) {
				var that = this;
				if (e.code != 1) {
					that.$Message.warning(e.msg);
					return;
				}
				that.fileUrl = e.data.url;
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: '文件类型不正确.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: '文件大小超出2M.'
				});
			},
			handleUpload: function(res) {
				let that = this;
				return new Promise(function(resolve, reject) {
					that.$Modal.confirm({
						title: '系统提示',
						content: '<p>确定导入吗？</p>',
						onOk: () => {
							that.loadingStatus = true;
							that.current_import_step = 1;
							resolve();
						},
						onCancel: () => {
							reject();
						}
					});
				});
			},
			uploadFile(e) {
				var that = this;
				this.loadingStatus = false;
				that.current_import_step = 3;
				if (e.code != 1) {
					that.$Message.warning(e.msg);
					return;
				}
			},

		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #5555ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>